import React from 'react';
import { IAccount } from '../models/Account';
import { inject, observer } from 'mobx-react';
import AuthenticationStore from '../stores/AuthenticationStore';

const Authorization = (
    AuthorizedComponent : typeof React.Component, 
    UnauthorizedComponent : typeof React.Component, 
    role : string
  ) => {
  @inject((allStores : any) => {
    return {
      authenticationStore: allStores.authenticationStore as AuthenticationStore
    };
  })
  @observer
  class WithAuthorization extends React.Component<{authenticationStore: AuthenticationStore}> {
    render() {
      const notAuthorized = <UnauthorizedComponent {...this.props} />;
      const authorized = <AuthorizedComponent {...this.props} />;

      const { account, payloadHasRole } = this.props.authenticationStore;
      if (account === null) {
        return payloadHasRole(role) ?
          authorized :
          notAuthorized;
      }

      if ((account as IAccount).hasRole(role))
        return authorized;

      return notAuthorized;
    }
  }

  return WithAuthorization;
};

export default Authorization;